import {DynamicColumnTable} from '@/components/organisms';
import {SELECTION_TYPE} from '@/utils/constants/commonConstants';
import {useTierList} from './useTierList';
import {TierFileUploadModal} from '@/containers/ClubPlus/Tabs/Overview/TierFileUploadModal/TierFileUploadModal';
import './_tier-list.scss';

export const TierList = () => {
  const {
    tiers,
    isLoadingTiers,
    getColumns,
    isFileUploadModalOpen,
    setIsFileUploadModalOpen,
    handleModalClose,
    setFormData,
    formData,
    selectedTierInfo,
    invalidateTiers
  } = useTierList();

  const {name, id} = selectedTierInfo;

  return (
    <div className='overview-table'>
      <DynamicColumnTable
        columns={getColumns()}
        records={tiers}
        showColumnFilters={false}
        selection={SELECTION_TYPE.NONE}
        isLoading={isLoadingTiers}
      />
      {isFileUploadModalOpen ? (
        <TierFileUploadModal
          isVisible={isFileUploadModalOpen}
          setIsVisible={setIsFileUploadModalOpen}
          onDismiss={handleModalClose}
          formData={formData}
          setFormData={setFormData}
          tierID={id}
          tierName={name}
          key={id}
          onSuccess={invalidateTiers}
        />
      ) : null}
    </div>
  );
};
